import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import {
  DownloadFile,
  DownloadFileResult,
  FileClient,
  FileResponse,
  UploadFile,
  UploadFileResult,
} from '@api';
import { TranslateService } from '@ngx-translate/core';
import { MandantConfigService } from '@strategies';
import { saveAs } from 'file-saver';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class FileService {
  private fileClient = inject(FileClient);
  private httpCient = inject(HttpClient);
  private translateService = inject(TranslateService);
  private mandant = inject(MandantConfigService);

  public downloadFile(id: string, contentType: string | undefined) {
    const fileReq = { id } as DownloadFile;
    return this.fileClient.downloadFile(contentType, fileReq);
  }

  public getFileLink(id: string) {
    const fileReq = { id } as DownloadFile;

    return this.fileClient.getFileLink(fileReq);
  }

  public saveFile(fileResponse: FileResponse, fileName: string) {
    saveAs(fileResponse.data, fileName);
  }

  public saveFileLink(fileResult: DownloadFileResult, fileName: string | undefined) {
    if (fileResult.link !== undefined) {
      this.httpCient.get(fileResult.link, { responseType: 'blob' }).subscribe(response => {
        saveAs(response, fileName);
      });
    }
  }

  public uploadFile(files: UploadFile[]): Observable<UploadFileResult[]> {
    return this.fileClient.uploadFile(files);
  }

  public fileRead(file: File): Promise<string> {
    return new Promise((resolve, reject) => {
      const fr = new FileReader();
      fr.onload = () => {
        resolve(fr.result as string);
      };
      fr.onerror = reject;
      fr.readAsDataURL(file);
    });
  }

  public validateFile(file?: File): [boolean, string, string] {
    let isValid = true;
    let message = '';
    const title = this.translateService.instant('fileUpload.error.title_error');
    if (file) {
      if (file.name.length > 150) {
        message = this.translateService.instant(
          'fileUpload.error.message__filename_length_too_large'
        );
        isValid = false;
      }

      if (file.size <= 0) {
        message = this.translateService.instant('fileUpload.error.message__file_size_too_small');
        isValid = false;
      }

      if (file.size > 1024 * 1024 * 10) {
        message = this.translateService.instant('fileUpload.error.message__file_size_larger10');
        isValid = false;
      }
    }
    return [isValid, message, title];
  }

  public validateTotalFileSize(
    files: File[],
    fileSizeAccessor: (accumulator, current: any) => number,
    maxMB: number
  ) {
    let isValid = true;
    let message = '';
    const title = this.translateService.instant('fileUpload.error.title_error');
    if (this.mandant.mandant.name === 'pasm') {
      const totalSize = files.reduce(fileSizeAccessor, 0);
      if (totalSize > 1024 * 1024 * maxMB) {
        message = this.translateService.instant('fileUpload.error.message__file_size_larger20', {
          maxMB,
        });
        isValid = false;
      }
      if (totalSize <= 0) {
        message = this.translateService.instant('fileUpload.error.message__file_size_too_small');
        isValid = false;
      }
    }
    return [isValid, message, title];
  }
}
